import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

class PdfHeader extends Component {
	render() {
		return (
			<div className="results-document-layout-header">
				{this.props.children}
			</div>
		);
	}
}
PdfHeader.propTypes = {
	children: PropTypes.node
};
export default PdfHeader;
